import { render, staticRenderFns } from "./refund.vue?vue&type=template&id=6475b463"
import script from "./refund.vue?vue&type=script&lang=ts"
export * from "./refund.vue?vue&type=script&lang=ts"
import style0 from "./refund.vue?vue&type=style&index=0&id=6475b463&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports